import { LayerDefinition } from './types';

export const sstDefinition: LayerDefinition = {
  id: 'sst',
  name: 'Sea Surface Temperature',
  category: 'environment',
  categoryLabel: 'Marine & Oceanographic',
  icon: '🌊',
  description: 'High-resolution sea surface water temperatures coupled with NOAA NDBC real-time buoy observations.',
  sourceModels: ['NOAA Coral Reef Watch (CRW) 5km SST', 'NOAA NDBC Marine Buoy Stations'],
  outputModels: ['SST temperature .pmtiles', 'Live marine buoy observation telemetry']
};

export default sstDefinition;
